import { withAuthGate } from '@sunrise-ui/composites';
import IntroductionView from '@templates/IntroductionView';
import React from 'react';

function PendingIntroScreen() {
  return <IntroductionView />;
}

export default withAuthGate(PendingIntroScreen);
